import React from "react";

// Barras simples por dia. `destacarDesde` pinta de outra cor os dias a partir
// de uma data (ex.: desde que a campanha ligou) — a linha de base fica apagada.
export default function BarrasPorDia({ serie, valor, rotulo, destacarDesde }) {
  if (!serie || serie.length === 0) {
    return <p className="text-xs text-muted-foreground py-4 text-center">Sem dados no período.</p>;
  }
  const maximo = Math.max(...serie.map(valor), 1);
  return (
    <div>
      <div className="flex items-end gap-1 h-24" role="img" aria-label={rotulo}>
        {serie.map((d) => {
          const v = valor(d);
          const depois = !destacarDesde || d.dia >= destacarDesde;
          return (
            <div key={d.dia} className="flex-1 h-full flex flex-col justify-end min-w-[4px]" title={`${d.dia.split("-").reverse().slice(0, 2).join("/")}: ${v}`}>
              <div
                className={`rounded-t ${depois ? "bg-purple-500" : "bg-muted-foreground/30"}`}
                style={{ height: `${Math.max(2, (v / maximo) * 100)}%` }}
              />
            </div>
          );
        })}
      </div>
      <div className="flex justify-between text-[10px] text-muted-foreground mt-1 tabular-nums">
        <span>{serie[0].dia.split("-").reverse().slice(0, 2).join("/")}</span>
        <span>{serie[serie.length - 1].dia.split("-").reverse().slice(0, 2).join("/")}</span>
      </div>
    </div>
  );
}
